'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { FaqSupportProfessionalsCard } from './cards/faq-support-professionals-card.component';

import { Button } from '@/components/ui/button/button.component';
import { Card } from '@/components/ui/card.component';
import { styleFaq } from '@/app/(main)/(pages)/(institucional)/preciso-de-ajuda/_consts/style-faq.consts';
import { Link } from '@/components/ui/link/link.component';
import { beOurPartnerUrl, partnerUrl } from '@/utils/consts/partner.consts';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';
import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';

export const FaqProfessionalTabContent = () => {
  const { buttonLgFit } = styleFaq();
  const analytics = getAnalyticsPlugin();

  return (
    <div className="flex flex-col gap-5">
      <Card
        className="flex flex-col md:flex-row gap-3 p-5"
        data-testid={DataTestIdEnum.FAQ_PROFESSIONAL_CTA_CARD}
      >
        <Button
          data-testid={DataTestIdEnum.FAQ_PROFESSIONAL_BE_OUR_PARTNER_BUTTON}
          asChild
          className={buttonLgFit()}
        >
          <Link prefetch={false} href={beOurPartnerUrl} target="_blank" data-analytics-event={AnalyticsEnum.CLICK_FAQ_PROFESSIONAL_SAC_EMAIL_BUTTON}>
            Quero atender pela Medprev
          </Link>
        </Button>
        <Button
          data-testid={DataTestIdEnum.FAQ_PROFESSIONAL_ENTER_SYSTEM_BUTTON}
          asChild
          className={buttonLgFit()}
          variant="secondary"
          onClick={() => {
            analytics.track(AnalyticsEnum.CLICK_FAQ_PROFESSIONAL_ACCESS_SYSTEM);
          }}
        >
          <Link prefetch={false} href={partnerUrl} target="_blank">
            Entrar no sistema
          </Link>
        </Button>
      </Card>

      <FaqSupportProfessionalsCard />
    </div>
  );
};
